// extracted by mini-css-extract-plugin
module.exports = {"footer":"Approval_footer__2uAYr","approvers":"Approval_approvers__4engP"};